import { useState, useEffect } from 'react';

import { useRouter } from 'next/router';
import SearchForm from 'ui/layouts/SearchForm';

const SearchPageForm = ({ children, onSubmit, ...attrs }) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const onComplete = () => setIsLoading(false);
    router.events.on('routeChangeComplete', onComplete);
    router.events.on('routeChangeError', onComplete);
    return () => {
      router.events.off('routeChangeComplete', onComplete);
      router.events.off('routeChangeError', onComplete);
    };
  }, [router]);
  const handleSubmit = (search) => {
    if (!search) {
      return;
    }
    setIsLoading(true);
    router.push(`/search/${search}`);
    if (onSubmit) {
      onSubmit(search);
    }
  };
  return (
    <SearchForm {...attrs} isLoading={isLoading} onSubmit={handleSubmit}>
      {(renderProps) => children && children({ ...renderProps, isLoading })}
    </SearchForm>
  );
};

export default SearchPageForm;
